import { FunctionComponent } from "react";
import { Modal } from "rs-emd-ui-atoms";
import { getLabel } from "../../../../helpers/html.utils";
import { ILabel } from "../../../../models/label.model";
import styles from "./country-details-component.module.scss";

type CountryDetailsProps = {
  labels: ILabel[];
  country: string;
  closeCallback: () => void;
};

export const CountryDetails: FunctionComponent<CountryDetailsProps> = (
  props: CountryDetailsProps
) => {
  const showOpeningHours =
    getLabel(props.labels, "openingHours") !== "openingHours" &&
    getLabel(props.labels, "openingHours") !== "";
  const showFax =
    getLabel(props.labels, "fax") !== "fax" &&
    getLabel(props.labels, "fax") !== "";
  const showEmail =
    getLabel(props.labels, "email") !== "email" &&
    getLabel(props.labels, "email") !== "";
  const showPhone =
    getLabel(props.labels, "telephone") !== "telephone" &&
    getLabel(props.labels, "telephone") !== "";
  const showMobile =
    getLabel(props.labels, "mobile") !== "mobile" &&
    getLabel(props.labels, "mobile") !== "";
  const showExtraNote =
    getLabel(props.labels, "extraNote") !== "extraNote" &&
    getLabel(props.labels, "extraNote") !== "";

  return (
    <Modal
      className={styles["modal-address-container"]}
      headerElt={<h3 className={styles["modal-title"]}>{props.country}</h3>}
      closeCallback={props.closeCallback}
      isClosable={true}
      headerClassName={styles.header}
    >
      <div className={styles["div-wrapper"]}>
        <div className={styles["div-section"]}>
          <h1 className={styles["h1-title"]}>Address</h1>
          {getLabel(props.labels, "address")
            .split("|")
            .map((p) => {
              return (
                <p key={p} className={styles["address"]}>
                  {p}
                </p>
              );
            })}
        </div>

        <div className={styles["div-section"]}>
          {showPhone && (
            <h1 className={styles["h1-title"]}>
              {getLabel(props.labels, "telephoneLabel")}
            </h1>
          )}
          {showPhone &&
            getLabel(props.labels, "telephone")
              .split(",")
              .map((p) => {
                return (
                  <div key={p}>
                    <a
                      className="link"
                      href={`tel:${getLabel(props.labels, "telephone")}`}
                    >
                      {p}
                    </a>
                  </div>
                );
              })}
          {showOpeningHours && (
            <p className={styles["opening-hours"]}>
              {getLabel(props.labels, "openingHours")}
            </p>
          )}
        </div>

        {showMobile && (
          <div className={styles["div-section"]}>
            <h1 className={styles["h1-title"]}>
              {getLabel(props.labels, "mobileLabel")}
            </h1>
            <p>{getLabel(props.labels, "mobile")}</p>
          </div>
        )}

        {showFax && (
          <div className={styles["div-section"]}>
            <h1 className={styles["h1-title"]}>
              {getLabel(props.labels, "faxLabel")}
            </h1>
            <p>{getLabel(props.labels, "fax")}</p>
          </div>
        )}

        {showEmail && (
          <div className={styles["div-section"]}>
            <h1 className={styles["h1-title"]}>
              {getLabel(props.labels, "emailLabel")}
            </h1>
            <a
              className="link"
              href={`mailto:${getLabel(props.labels, "email")}`}
            >
              {getLabel(props.labels, "email")}
            </a>
          </div>
        )}

        {showExtraNote && (
          <div className={styles["div-section"]}>
            <p className={styles["extra-note"]}>
              {getLabel(props.labels, "extraNote")}
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};
